import { backendApi } from '../../config'

export type AvailabilityResponse = {
  available: boolean
}

export const checkCreatorEmailAvailability = async (
  email: string
): Promise<AvailabilityResponse> => {
  const response = await backendApi.get<AvailabilityResponse>(
    '/api/creators/availability/email',
    { params: { email } }
  )
  return response.data
}

export const checkCreatorDocumentAvailability = async (
  document: string
): Promise<AvailabilityResponse> => {
  const response = await backendApi.get<AvailabilityResponse>(
    '/api/creators/availability/document',
    { params: { document: document.replace(/\D/g, '') } }
  )
  return response.data
}
